<template>
  <div class="container">
    <!-- <div class="yindaoru" @click="dianjig" v-if="yina">
      <div class="qian">点击可前往学习系统</div>
      <video
        src="../assets/yin.mp4"
        class="videp"
        autoplay="true"
        loop="true"
        muted="“muted”"
      ></video>
    </div> -->
    <div class="head_nav" style="background: #fcfcfc">
      <!-- 
        :style="{
          background:
            'url(' +
            require('../assets/img/' + bei_ing) +
            ') no-repeat center center',
          'background-size': '100% 100%',
        }"
       -->
      <div class="head__bg" style="background: #59a0ef">
        <div class="w">
          <div class="date__search">
            <div class="data_item">
              <!-- {{ calendar }} -->
            </div>
            <div class="search__mite">
              <div class="sh_input">
                <input
                  placeholder="输入关键词"
                  v-model="text"
                  class="s_input"
                  @keyup.enter.prevent="searchEnterFun($event)"
                />
              </div>
              <div class="sh_icon" @click="search">
                <img src="../assets/img/img_06.png" alt="" />
              </div>
            </div>
          </div>
          <div class="center__logo" style="margin-top: -77px">
            <img src="../assets/img/img_12.png" class="logo__img" alt="" />
          </div>
        </div>
      </div>
      <div class="head__nav">
        <div class="w">
          <div class="head__ited">
            <div class="hd__left">
              <template v-for="(item, index) in headNav" >
                <div
                  class="tab__name"
                  :class="orderindex == index ? 'head__active' : ''"
                  :data-index="index"
                  @click="changeTitle"
                  v-if="item != '下载中心'"
                >
                  {{ item }}
                </div>
              </template>
            </div>
            <div class="tui__out" v-if="isLogin == true">
              <div
                class="left_hd__img"
                :class="isLogin == false ? 'is_login_style' : ''"
              >
                <img :src="avatarimg" alt="" />
                <div class="nick__name title_one">
                  {{ username }}
                </div>
              </div>
              <div class="tui__cion">
                <div class="tui__right" @click="goLoginOut">
                  <img src="../assets/img/img_08.png" alt="" />
                  <div class="tui__name">退出</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      bei_ing: "img_29.png",
      headNav: [
        "首页",
        "通知公告",
        "行业资讯",
        "精选课程",
        "学习中心",
        "下载中心",
        "行业平台",
        "联系我们",
      ],
      noticeList: 9,
      rukou: [],
      callList: [],
      orderindex: 0,
      is_login: false,
      calendar: "",
      yina: false,
      text: "",
    };
  },
  computed: {
    ...mapState(["avatarimg", "isLogin", "username"]),
  },
  created() {
    this.getNowDate();
    let token = localStorage.getItem("token-qzb");
    if (sessionStorage.getItem("orderindex")) {
      this.orderindex = sessionStorage.getItem("orderindex");
    } else {
      this.orderindex = 0;
    }
    console.log(token, "登录token");
    if (token) {
      this.getinfo();
      this.isclickLogin(true);
    }
  },
  methods: {
    ...mapActions(["userinfo", "userinfoEmpty", "isclickLogin"]),
    //点击回车，进行搜索
    searchEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.search();
      }
    },
    //搜索
    search() {
      let that = this;
      this.$emit("addservere", 2);
      this.$emit("paget", 1);
      sessionStorage.setItem("key-word", this.text);
      let count = Number(this.orderindex);
      switch (count) {
        case 0:
          that.type = 1;
          that.getsou(count);
          break;
        case 1:
          that.type = 1;
          that.getsou(count);
          break;
        case 2:
          that.type = 4;
          that.getsou(count);
          break;
        case 3:
          that.type = 2;
          that.getsou(count);
          break;
        case 4:
          that.type = 3;
          that.getsou(count);
          break;
        case 5:
          that.type = 5;
          that.getsou(count);
          break;

        default:
          break;
      }
    },
    //搜索接口
    getsou(count) {
      let that = this,
        url = "lists/sou",
        is_count = Number(count),
        param = {
          page: that.page,
          pageNum: that.pageNum,
          keyword: that.text,
          type: that.type,
          id: that.id,
        };
      this.post(url, param)
        .then((res) => {
          console.log(res);
          switch (is_count) {
            case 0:
              if (res.data.total_num != 0) {
                this.$router.push({
                  path: "/inform",
                  query: { info: JSON.stringify(res.data) },
                });
                sessionStorage.setItem("orderindex", 1);
              } else {
                this.$message.error("未查询到相关数据");
              }
              break;
            case 1:
              this.$emit("cart-tatus", res.data);
              break;
            case 2:
              this.$emit("cart-tatus", res.data);
              break;
            case 3:
              this.$emit("cart-tatus", res.data);
              break;
            case 4:
              this.$emit("cart-tatus", res.data);
              break;
            case 5:
              this.$emit("cart-tatus", res.data);
              break;
            default:
              this.$emit("cart-tatus", res.data);
              break;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getNowDate() {
      var nowDate = new Date();
      var lunar = this.Calendar.solar2lunar(
        nowDate.getFullYear(),
        nowDate.getMonth() + 1,
        nowDate.getDate()
      );
      var str =
        lunar.cYear +
        "年" +
        lunar.cMonth +
        "月" +
        lunar.cDay +
        "日 " +
        lunar.IMonthCn +
        lunar.IDayCn +
        "，" +
        lunar.gzYear +
        "年" +
        lunar.gzMonth +
        "月" +
        lunar.gzDay +
        "日（" +
        lunar.Animal +
        "年）";
      console.log(str);
      this.calendar = str;
    },
    getinfo() {
      //顶部图片接口
      let that = this,
        url = "user/index",
        param = {
          token: localStorage.getItem("token-qzb"),
        };
      that
        .post(url, param)
        .then((res) => {
          console.log(res);
          that.userinfo(res.data);
        })
        .catch((err) => {
          console.log(err);
          that.$message.error(err.msg);
        });
    },
    changeTitle(e) {
      let that = this,
        od = Number(e.currentTarget.dataset.index);
      console.log(od);
      that.orderindex = od;
      switch (od) {
        case 0:
          this.$router.push({ path: "/" });
          sessionStorage.setItem("orderindex", this.orderindex);
          break;
        case 1:
          this.$router.push({ path: "/inform" });
          sessionStorage.setItem("orderindex", this.orderindex);
          break;
        case 2:
          this.$router.push({ path: "/policy" });
          sessionStorage.setItem("orderindex", this.orderindex);
          break;
        case 3:
          this.$router.push({ path: "/curriculum" });
          sessionStorage.setItem("orderindex", this.orderindex);
          break;
        case 4:
          this.$router.push({ path: "/learn" });
          sessionStorage.setItem("orderindex", this.orderindex);
          // if (sessionStorage.getItem("xue")) {
          // } else {  // 暂无视频，。无需设置
          //   sessionStorage.setItem("xue", 1);
          // }
          break;
        case 5: //  下载专区
          this.$router.push({ path: "/downloadSection" });
          sessionStorage.setItem("orderindex", this.orderindex);
          break;
        case 6: // 行业网站
          this.$router.push({ path: "/system" });
          sessionStorage.setItem("orderindex", this.orderindex);
          break;
        case 7: // 联系我们
          this.$router.push({ path: "/contactUs" });
          sessionStorage.setItem("orderindex", this.orderindex);
          break;
        default:
          break;
      }
    },
    goLogin() {
      // 登录
      this.$router.push("/login");
    },
    goLoginOut() {
      // 登出
      sessionStorage.setItem("orderindex", 0);
      localStorage.clear();
      this.orderindex = 0;
      this.isclickLogin(false);
      this.userinfoEmpty();
      this.$router.push("/");
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  .head_nav {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;

    .head__bg {
      width: 100%;
      height: 163px;
      height: 75px;

      .date__search {
        width: 100%;
        padding: 18px 0 23px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .data_item {
          flex: 1;
          font-size: 14px;
          font-family: Source Han Sans CN, Source Han Sans CN-Medium;
          font-weight: 500;
          text-align: left;
          color: #ffffff;
        }

        .search__mite {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: flex-end;

          .sh_input {
            width: 284px;
            height: 42px;
            line-height: 42px;
            background: #ffffff;
            border-radius: 10px 0px 0px 10px;
            .s_input {
              padding-left: 16px;
              box-sizing: border-box;
              width: 100%;
              height: 26px;
              border: 0 none;
            }
          }

          .sh_icon {
            width: 67px;
            height: 42px;
            background: #3f51b5;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 0px 10px 10px 0px;

            img {
              width: 20px;
              height: 20px;
            }
          }
        }
      }

      .center__logo {
        width: 100%;
        height: 65px;
        margin-bottom: 32px;
        display: flex;
        align-items: center;
        // justify-content: center;

        .logo__img {
          height: 65px;
        }
      }
    }

    .head__nav {
      width: 100%;
      height: 110px;
      background: #59a0ef;
      display: flex;
      align-items: center;

      .head__ited {
        width: 100%;
        display: flex;
        align-items: center;

        .hd__left {
          flex: 1;
          display: flex;
          align-items: center;

          .tab__name {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 20px;
            font-family: Source Han Sans CN, Source Han Sans CN-Regular;
            font-weight: 400;
            color: #ffffff;
            line-height: 24px;
            height: 50px;
            border-radius: 40px;
          }

          .head__active {
            background-color: #ffffff;
            color: #333333;
          }
        }

        .tui__out {
          width: 157px;
          height: 40px;
          background: #ffffff;
          border-radius: 20px;
          flex-shrink: 0;
          padding: 0 16px 0 6px;
          box-sizing: border-box;
          margin-left: 50px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .left_hd__img {
            flex: 1;
            display: flex;
            align-items: center;

            img {
              width: 24px;
              height: 24px;
              margin-right: 4px;
              border-radius: 50%;
            }

            .nick__name {
              width: 71px;
              font-size: 14px;
              font-family: Source Han Sans CN, Source Han Sans CN-Regular;
              font-weight: 400;
              text-align: left;
              color: #06121e;
              line-height: 24px;
            }
          }
          .tui__cion {
            width: 28px;
            border-left: 1px solid #c98e65;
            display: flex;
            align-items: center;
            justify-content: flex-end;

            .tui__right {
              width: 24px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;

              img {
                width: 20px;
                height: 20px;
              }
              .tui__name {
                font-size: 10px;
                font-family: Source Han Sans CN, Source Han Sans CN-Regular;
                font-weight: 400;
                text-align: right;
                color: #d6a07a;
              }
            }
          }

          .is_login_style {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            .nick__name {
              font-size: 20px;
              color: #19428e;
              width: 80px;
            }
          }
        }
      }
    }
  }
}
</style>
